/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Pesquisar',
  search_no_results_1: 'Ops!',
  search_no_results_2: 'Não foi possível encontrar este emoji',
  pick: 'Escolha um emoji…',
  add_custom: 'Adicionar emoji personalizado',
  categories_activity: 'Atividades',
  categories_custom: 'Personalizados',
  categories_flags: 'Bandeiras',
  categories_foods: 'Comida e bebida',
  categories_frequent: 'Usados frequentemente',
  categories_nature: 'Animais e natureza',
  categories_objects: 'Objetos',
  categories_people: 'Emoticons e pessoas',
  categories_places: 'Viagem e lugares',
  categories_search: 'Resultados da pesquisa',
  categories_symbols: 'Símbolos',
  skins_choose: 'Escolha o tom de pele padrão',
  skins_1: 'Padrão',
  skins_2: 'Claro',
  skins_3: 'Claro médio',
  skins_4: 'Médio',
  skins_5: 'Escuro médio',
  skins_6: 'Escuro',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
